import TagManager from 'react-gtm-module';
import {
  updatePageTitle,
  updatePlatformDataLayer,
  getStoreDetails,
  bannerNameValueFunc,
  isImzFlowType,
} from './utils';

function DataLayerFunction(
  pageTitleDataImz,
  pageTitleDataRx,
  gtmDataObject,
  subSection1,
) {
  const pageTitleName = isImzFlowType ? pageTitleDataImz : pageTitleDataRx;
  const dataLayerObject = gtmDataObject;
  updatePageTitle(pageTitleName);
  const storeDetailsObj = getStoreDetails();
  const shopStoreId = storeDetailsObj !== null ? storeDetailsObj.storeId : '';
  const shopZipCode =
    storeDetailsObj !== null ? storeDetailsObj.storeZipcode : '';
  dataLayerObject.page.pageName = pageTitleName;
  dataLayerObject.page.subSection1 = subSection1;

  dataLayerObject.page.banner = bannerNameValueFunc();
  dataLayerObject.user.banner = bannerNameValueFunc();
  dataLayerObject.page.platform = updatePlatformDataLayer();
  dataLayerObject.user.shopStoreId = shopStoreId;
  dataLayerObject.user.shopZipCode = shopZipCode;
  dataLayerObject.page.pageUrl = window.location.href;
  const tagManagerArgs = {
    dataLayer: dataLayerObject,
  };
  TagManager.dataLayer(tagManagerArgs);
}

export { DataLayerFunction };
